import { Facility } from '../models';

const STATE = {
    CA: 'CA',
    AK: 'AK',
    VI: 'VI'
};

export class FacilityHelperService {
    static isCA(facility: Facility): boolean {
        return facility?.hospitalState?.startsWith(STATE.CA);
    }

    static isAK(facility: Facility): boolean {
        return facility?.hospitalState?.startsWith(STATE.AK);
    }

    static isVI(facility: Facility): boolean {
        return facility?.hospitalState?.startsWith(STATE.VI);
    }

    static isSpecialState(facility: Facility): boolean {
        return this.isAK(facility) || this.isCA(facility) || this.isVI(facility);
    }
}
